export default {
	name: 'customerAddress',
	data() {
		return {
			getData: {},
			customerID: 0,
			customer: {},
			customerPhone: '',
			ReceivingAddress: '',
			Edit: '',
			OperatorID: this.$store.state.user.UserID,
			clear: {},
			addressID: 0
		};
	},
	created() {
		this.getData = function() {
			this.customerID = this.$route.params.customerID;
			this.$request.request({
				url: 'customer/getCustomerByCustomerID',
				data: {
					CustomerID: this.customerID
				},
				method: 'post'
			}).then(res => {
				if (res.result) {
					this.customer = res.customer;
					this.customerPhone = res.customer.CustomerPhone;
				}
			});
		}
		this.clear = () => {
			this.ReceivingAddress = '';
			this.customerPhone = this.customer.CustomerPhone;
			this.addressID = 0;
		}

	},
	methods: {
		setDeault(i){
			 
			this.$request.request({
				url: 'customer/setDefaultAddress',
				data: {
					CustomerID: this.customerID,
					AddressID: i.AddressID
				},
				method: 'post'
			}).then(res => {
				if (res.result) {
					this.customer = res.customer;
					this.customerPhone = res.customer.CustomerPhone;
				}
			});
		},
		addAddress() {
			if (this.customer.boxMoney < 60) {
				this.$uil.showMessage({
					text: '请先购买书箱'
				});
				return;
			}
			this.clear();
			this.Edit = 'add';
		},
		editAddress() {
			this.$request.request({
				url: 'customer/editAddress',
				data: {
					CustomerID: this.customerID,
					AddressID: this.addressID,
					Phone: this.customerPhone,
					ReceivingAddress: this.ReceivingAddress,
					OperatorID: this.OperatorID
				},
				method: 'post'
			}).then(res => {
				if (res.result) {
					this.customer = res.customer;
					this.customerPhone = res.customer.CustomerPhone;
				}
				this.$uil.showMessage({
					text: res.message
				});
				this.Edit ='';
			});
		},
		updateAddress(i) {
			this.ReceivingAddress = i.ReceivingAddress;
			this.customerPhone = i.Phone;
			this.addressID = i.AddressID;
			this.Edit = 'update';
		}
	},
	computed: {
		checkAddress() {
			 
			return this.$uil.checkPhone(this.customerPhone) && this.ReceivingAddress.length > 10;
		}
	},
	activated() {
		this.getData();
	},
	watch: {
		$route(n, o) {
			// if (n.path.indexOf('/newCustomers/customerAddress') == -1) return;
			// let ncustomerID = n.params.customerID;
			// let ocustomerID = o.params.customerID;
			// if (ncustomerID != ocustomerID)

		}

	}
}
